import * as React from 'react';

import { Link } from '../link/link';

const s = require('./sale_item_block.css');

interface IProps {
  onAdsClick(eventLabel: string): void;
}

export const ContactManagerBlock = (props: IProps) =>
  <div className={`${s['c-selfad-single-actions']} cg-col-6 cg-col-s-7 cg-col-xs-6`}>
    <Link
        className={s['c-selfads-item-button']}
        onClick={() => props.onAdsClick('contact')}
        href="/contacts/"
        target="_blank">
      Связаться с менеджером
    </Link>
  </div>;
